export default "__VITE_ASSET__CZtIuxFI__"